import { getLocalParticipant } from '../base/participants/functions';
import { sendMessage } from '../chat/actions';
import { setOverflowMenuVisible } from '../toolbox/actions';
import {
  RESET_WHITEBOARD,
  SETUP_WHITEBOARD,
  SET_WHITEBOARD_OPEN
} from './actionTypes';
import { getCollabDetails, isWhiteboardVisible } from './functions';

/**
 * Configures the whiteboard collaboration details.
 *
 * @param {Object} payload - The whiteboard settings.
 * @returns {{
 *     type: SETUP_WHITEBOARD,
 *     collabDetails: { roomId: string, roomKey: string }
 * }}
 */
export const setupWhiteboard = (data) => {
  return {
    type: SETUP_WHITEBOARD,
    data
  };
};

/**
 * Cleans up the whiteboard collaboration settings.
 * To be used only on native for cleanup in between conferences.
 *
 * @returns {{
 *     type: RESET_WHITEBOARD
 * }}
 */
export const resetWhiteboard = () => {
  return { type: RESET_WHITEBOARD };
};

/**
 * Sets the whiteboard visibility status.
 *
 * @param {boolean} isOpen - The whiteboard visibility flag.
 * @returns {{
 *      type: SET_WHITEBOARD_OPEN,
 *      isOpen
 * }}
 */
export const setWhiteboardOpen = (isOpen) => {
  return {
    type: SET_WHITEBOARD_OPEN,
    isOpen
  };
};

/**
 * Hides the toolbox.
 *
 * @param {boolean} force - True to force the hiding of the toolbox without
 * caring about the extended toolbar side panels.
 * @returns {Function}
 */
export function toggleWhiteboard() {
  return (dispatch, getState) => {
    const state = getState();
    const visible = isWhiteboardVisible(state);
    dispatch(setWhiteboardOpen(!visible));
    dispatch(setOverflowMenuVisible(false));
    if (getCollabDetails(state)) {
      const message = {
        EventType: visible ? 22 : 21,
        Message: 'Whiteboard',
        FromParticipantID: getLocalParticipant(state).id
      };

      dispatch(sendMessage(JSON.stringify(message)));
    }
  };
}
